import { Button } from '@mui/material'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { motion } from 'framer-motion';
import { fadeIn, staggerContainer } from '../../../utils/motion';
import { Helmet } from 'react-helmet';

import img from '../../../assets/about/about.webp'

const AboutBanner = () => {

    const navigate = useNavigate()

    return (
        <div className='main-class'>

            <motion.div
                variants={staggerContainer}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true }}>
                <div className='grid grid-cols-1 md:grid-cols-2  md:gap-4'>
                    <motion.div
                        variants={fadeIn('right', 'tween', 0, 1.0)}
                    >
                        <div className='p-2'>
                            <h1 className='font-bold text-2xl text-center md:text-left md:text-3xl dark:text-white'><span className='text-red-500'>CodeZone </span>- Accelerate Your Business Growth With Us!</h1>
                            <p className='my-4 md:my-4 text-gray-500 dark:text-gray-300 text-xs'>
                                Your business is only as good as the technology behind it. We have the expertise. You have the vision. We make technology happen! Our team of world-class engineers and innovators will build your next software project, leaving you to focus on running your business.<br/><br/>Got an idea? Bring it to life with CodeZone!
                            </p>
                        </div>
                    </motion.div>
                    <motion.div
                        variants={fadeIn('left', 'tween', 0, 1.0)}
                    >
                        <div className='flex items-center justify-center'>
                            <img src={img} alt="img"
                                className='object-contain cursor-pointer h-[350px] w-[80%] md:w-full'
                                onClick={() => navigate('/pricing')}
                            />
                        </div>
                    </motion.div>
                </div>
            </motion.div>
        </div>
    )
}

export default AboutBanner